import gql from "graphql-tag";

export const GetDashboardInfo = gql`
  query GetReports($date: QueryableDateTimeRange!) {
    accounts {
      type
      hasSales
      isNmiAccount
      subscription {
        currentPeriodEnd
      }
    }
    reports {
      overviewReport(date: $date) {
        totalVideos
        completedPurchases
        totalViewsCount
        totalSalesAmount
      }
      influencerReport {
        influencer {
          id
          name
          picture
        }
        totalRevenue
        totalVideoViews
      }
    }
  }
`;
